import React, { useEffect, useState } from 'react'
import MyInput from '../Interactions/MyInput'
import GradientButton from '../Button/GradientButton'
import topRightImage from '../../assets/images/create_channel_top.png';
import MyRadio from '../Interactions/MyRadio';
import { LoadingOutlined } from '@ant-design/icons';
import { generateRandomNumber } from '../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { getChannelListThunk, setChannelCreateLoader } from '../../slices/userSlice';

const VISIBILITY_DATA = [
    { 
        key: 'Public', 
        title: <div className="text-gray-600 text-lg">Public anyone in M3</div>, 
    },
    { 
        key: 'Private', 
        title: <>
                <div className="text-gray-600 text-lg">Private - Only specific people</div>
                <div className="text-gray-600">Can only be viewed or joined by invitation </div>
               </>, 
    }
]

const CreateNewChannelModal = ({ isShow, closeModal=()=>{} }) => {
    const dispatch = useDispatch();
    const [step, setStep] = useState(1);
    const [channelData, setChannelData] = useState({ ChannelName: '', Type: 'Public' });
    const userAttribute = useSelector(state => state.user.userAttributes);
    const channelCreateLoader = useSelector(state => state.user.channelCreateLoader);
    const isChannelCreated = useSelector(state => state.user.isChannelCreated);
    const websocket = useSelector((state) => state.socket.websocket);

    const handleNextStep = () => {
        setStep(2)
        // if(channelName.length > 0){}
    }

    useEffect(()=>{
        if(!channelCreateLoader && isChannelCreated){
            dispatch(getChannelListThunk());
            closeModal();
            dispatch(setChannelCreateLoader({ isChannelCreated: false, }));
        }
    }, [channelCreateLoader])


    const handleCreateChannel = () => {
        dispatch(setChannelCreateLoader({ load: true, }));
        const dataToBeSend = {
            PK: `Channel#${generateRandomNumber()}`,
            SK: channelData.Type + "#",
            ChannelName: channelData.ChannelName,
            CreatedBy: userAttribute?.sub?.includes("User#") ? userAttribute?.sub : `User#${userAttribute?.sub}`,
            RequestType: 'create-channel',
        }
        console.log(dataToBeSend, "=dataToBeSend:channelDataaaaaaa");

        // console.log(websocket.readyState, websocket);
        if (websocket && websocket.readyState === WebSocket.OPEN) {
            websocket.send(JSON.stringify({ action: "sendmessage", ...dataToBeSend }));
        } else {
            console.error("WebSocket is not connected.");
        }
    }

    if(!isShow) return <></>

    if(step === 1){
        return (
          <div onClick={closeModal} className='fixed top-0 left-0 z-[9999] h-screen w-screen bg-gray-400/50 flex justify-center items-center'>
            <div onClick={(e)=>e.stopPropagation()} className="relative bg-pureWhite rounded-2xl p-5 max-w-[670px]">
              <h2 className="text-black text-xl font-semibold font-bizmo">Create a channel</h2>
              <div className="mt-12">
                  <p className='text-gray-600 text-lg mb-3'>Channel Name</p>
                  <div className="shadow-sm">
                      <MyInput placeholder="Channel One" onChange={(e)=>setChannelData(prev => ({ ...prev, ChannelName: e.target.value }))} />
                  </div>
                  <p className='text-gray-400 text-base mt-4'>Channels are where conversations happen around a topic. Use a name that is easy to find and understand.</p>
              </div>
              <div className="mt-7 flex justify-between items-center">
                  <p className="text-xl">Step 1 of 2</p>
                  <GradientButton disabled={channelData.ChannelName.length === 0} onClick={handleNextStep}>Next</GradientButton>
              </div>
              <div className="absolute top-0 right-0">
                  <img src={topRightImage} alt="design" />
              </div>
            </div>
          </div>
        );
    }
    
    return (
        <div onClick={closeModal} className='fixed top-0 left-0 z-[9999] h-screen w-screen bg-gray-400/50 flex justify-center items-center'>
            <div onClick={(e)=>e.stopPropagation()} className="relative bg-pureWhite rounded-2xl p-5 w-[670px]">
                <h2 className="text-black text-xl font-semibold font-bizmo">Create a channel</h2>
                <h3 className="text-black text-base font-bizmo"># {channelData.ChannelName}</h3>
                <h2 className="text-black text-lg font-bold font-bizmo mt-9">Visability</h2>
                <div className="">
                    <MyRadio value={channelData.Type} defaultChecked="public" classNameForGroup="createChannelRadio flex flex-col" data={VISIBILITY_DATA} onChange={(text)=>setChannelData(prev => ({ ...prev, Type: text }))} />
                </div>
                <div className="mt-5 flex justify-between items-center">
                    <p className="text-xl">Step 2 of 2</p>
                    <div className='flex items-center gap-x-10'>
                        <button onClick={()=>setStep(1)} className='text-orange-gradient text-lg'>Back</button>
                        <GradientButton onClick={handleCreateChannel}>
                            Save
                            {channelCreateLoader && <LoadingOutlined size={30} style={{ color: 'white' }} />}
                        </GradientButton>
                    </div>
                </div>
                <div className="absolute top-0 right-0">
                    <img src={topRightImage} alt="design" />
                </div>
            </div>
        </div>
    );
}

export default CreateNewChannelModal
